/**
 * Класс AbstractDataSource предназначен для наследования частных классов - источнков данных
 */
class AbstractDataSource {
  /**
   * Создает экземпляр класса AbstractDataSource
   * @param params
   */
  constructor(params) {
    this.params = params || {};
    this.layer = undefined;
  }

  /**
   * Ссылка на объект
   * @return {AbstractDataSource}
   */
  getDataSource() {
    return this;
  }

  /**
   * Возвращает источник данных
   * @return {*}
   */
  getSource() {
    return this.source;
  }

  /**
   * Устанавливает источник данных
   * @param source
   */
  setSource(source) {
    this.source = source;
  }

  /**
   * Возвращает набор маппингов
   * @return {*}
   */
  getMappings() {
    if (this.params.mappings) return this.params.mappings;
    return {};
  }

  /**
   * Устанавливает набор маппингов
   * @param params
   */
  setMappings(params) {
    this.params.mappings = params;
  }

  /**
   * Возвращает алиас (псевдоним) для поля
   * @param item
   * @return {string|*}
   */
  getFieldAlias(item) {
    let mappings = this.getMappings() || {};
    let fieldName = item.fieldName || item.name;
    let alias = mappings[fieldName] && mappings[fieldName].alias ? mappings[fieldName].alias : fieldName;
    return alias;
  }
}

module.exports = AbstractDataSource;